import { Square } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import EnterpriseLayout from 'src/components/enterprise/layout/EnterpriseLayout';
import { MealCreditPageRoutes } from 'src/components/oneCorp/features/MealCredit/components/Routes/MealCreditPageRoutes';

export function MealCreditPage(): JSX.Element {
  return (
    <EnterpriseLayout pageTitle="Meal Credit">
      <Square inset="lg" paddingTop="12">
        <MealCreditPageRoutes />
      </Square>
    </EnterpriseLayout>
  );
}
